import { DragonchainConfig } from '.';

const linkResolver = (doc) => {
  if (doc.uid === 'landing') { return '/'; }
  if (doc.type === 'page_builder') { return `/${doc.uid}`; }
  if (doc.type === 'article') { return `/blog/${doc.uid}`; }
  if (doc.type === 'faq') { return '/resources/faq'; }

  return '/'; // Backup for all other types
};

const externalLink = (doc) => {
  const docLink = linkResolver(doc);
  return `https://${DragonchainConfig.DOMAIN}${docLink}`;
};

export { externalLink, linkResolver };
